/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Divide {
  /**
   * Divide two numbers as integers.
   *
   * @public
   * @function f1.divide
   * @return an integer
   * @param numerator the number divided
   * @param denominator the number to divide by, if zero, then the function returns 0
   * @example
   *
   * ```ts
   * f1.divide(2, 6) => 3
   * ```
   */
  (denominator: number, numerator: number): number;
  /**
   * {@link FnDivideValue}
   * @param denominator the number to divide by, if falsy will be 1
   */
  (denominator: number): (numerator: number) => number;
}

/**
 * @see Divide
 */
export default (denominator: number, numerator: number) => {
  return denominator === 0 ? 0 : (numerator | 0) / denominator;
};
